exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-item-title[data-v-218e9c4c]{border-radius:0 0 5px 5px}.tab-item-img[data-v-218e9c4c]{border-radius:5px 5px 0 0}[data-v-218e9c4c] .el-form-item__content{margin-right:30px!important;margin-left:80px!important}[data-v-218e9c4c] .el-loading-mask{background-color:rgba(0,0,0,.5)!important}", ""]);

// exports
